import { useTranslation } from "react-i18next";

import { router } from "@/components/Router";

import { useSideMenu } from "..";

export const SideMenuItem = ({
    route,
    title,
    icon,
    isCurrent,
    className = "",
}: {
    route: string;
    title: string;
    icon: React.ReactNode;
    isCurrent: boolean;
    className?: string;
}) => {
    const { t } = useTranslation();

    const { handleCloseSideMenu } = useSideMenu();

    return (
        <div
            draggable={false}
            className={
                className ||
                `bg-elitLightBackground select-none w transition-opacity no-underline text-elitDarkBlue h-full w-full flex items-center px-8 p-4 rounded-3xl ${
                    isCurrent ? "opacity-100" : "opacity-50 hover:opacity-75"
                }`
            }
            key={route}
            onClick={() => {
                handleCloseSideMenu();
                router.navigate(route);
            }}
        >
            {icon}
            <div
                className={`text-xs md:text-base font-semibold rounded-lg px-2 text-nowrap ${
                    isCurrent ? "bg-elitOrange ml-2" : ""
                }`}
            >
                {t(title)}
            </div>
        </div>
    );
};
